import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMenuVisible: false,
    user: null,
    showSignup: false,
    showPass: false
  },
  mutations: {
    toggleMenu (state, isVisible) {
      if (!state.user) {
        state.isMenuVisible = false;
        return;
      }

      if (isVisible === undefined) {
        state.isMenuVisible = !state.isMenuVisible;
      } else {
        state.isMenuVisible = isVisible;
      }
    },
    toggleSignup (state, isInfo) {
      if (isInfo === undefined) {
        state.showSignup = !state.showSignup;
      } else {
        state.showSignup = isInfo
      }
    },
    togglePassword (state, isInfo) {
      if (isInfo === undefined) {
        state.showPass = !state.showPass;
      } else {
        state.showPass = isInfo
      }
    },
    setUser (state, user) {
      state.user = user;
      if (user) {
        axios.defaults.headers.common["Authorization"] = `bearer ${user.token}`;
        state.isMenuVisible = true;
      } else {
        delete axios.defaults.headers.common["Authorization"];
        state.isMenuVisible = false;
      }
    }
  },
  actions: {},
  modules: {}
});